import { render, staticRenderFns } from "./Hotel.vue?vue&type=template&id=353abbfa&lang=pug&"
import script from "./Hotel.vue?vue&type=script&lang=ts&"
export * from "./Hotel.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports